/* State Interface Imports */

import StateInterface from "../state-interface";

/* Default State Imports */

import { business_profile } from "./sub-state-data";

/* Business Dashboard Page Default State Data */

const business_dashboard_data: StateInterface["business_dashboard"] = {
	business_profile: business_profile,
	business_profile_data_loading: true,
	show_contact_details_loading: false,
	receive_promotional_emails_loading: false,
	user_view_tab_value: 0,
	home_screen: {
		overview_widget: {
			loading: true,
			published_listings: 0,
			total_leads: 0,
			new_leads: 0,
			leads_ratio_percentage: 0,
			leads_ratio_is_negative: false,
			total_chats: 0,
			unread_chats: 0,
		},
		ai_boost_widget: {
			loading: true,
			active_campaigns: [],
			active_campaigns_count: 0,
		},
		performance_analysis_widget: {
			performance_analytics_data: [],
			total_listings: 0,
			loading: true,
		},
		notification_widget: {
			loading: true,
		},
		broadcast_widget: {
			broadcast_widget_data: [],
			loading: true,
		},
		agent_trends_widget: {
			top_agent_areas: [],
			total_agent_count: 0,
			loading: true,
		},
	},
	search_listings_response: {
		listing_ids: [],
		trigger_new_search: false,
		listings_loading: true,
		initial_load_done: false,
		listings_count: 0,
		filter_status: "all",
		filter_listing_type: "property",
		filter_transaction_type: "all",
		filter_sort_field: "created_at",
		filter_property_id: "",
		filter_sort_order: -1,
		filter_page_number: 1,
		listings_overview: {
			total_properties_count: 0,
			published_count: 0,
			in_review_count: 0,
			boosted_count: 0,
			listings_overview_loaded: false,
			sale_count: 0,
			rent_count: 0,
		},
		listings_filter_count: {
			listedCount: 0,
			unlistedCount: 0,
			listedSalesCount: 0,
			listedRentCount: 0,
			listedResaleCount: 0,
			unlistedSalesCount: 0,
			unlistedRentCount: 0,
			unlistedResaleCount: 0,
		},
		listings_filter_loading: false,
	},
	property_broadcast_response: {
		broadcast_ids: [],
		trigger_new_search: false,
		broadcasts_loading: true,
		initial_load_done: false,
		broadcasts_count: 0,
		filter_sort_field: "created_at",
		filter_sort_order: -1,
		filter_page_number: 1,
		filter_status: "all",
		status_counts: {
			all: 0,
			active: 0,
			in_review: 0,
			draft: 0,
		},
		broadcasts_overview: {
			sent_count: 0,
			received_count: 0,
			broadcasts_overview_loaded: false,
		},
		broadcasted_property_id: "",
	},
	search_leads_response: {
		lead_ids: [],
		trigger_new_search: false,
		leads_loading: true,
		initial_load_done: false,
		leads_count: 0,
		filter_status: "all",
		filter_assigned_status: "all",
		filter_listing_type: "all",
		filter_sort_field: "created_at",
		filter_sort_order: -1,
		filter_page_number: 1,
		filter_property_id: "",
		filter_boost_ids: [],
		filter_campaign_ids: [],
		filter_selected_campaign_id: "",
		filter_date_range: { option: "newest", start_date: "", end_date: "" },
		filter_assigned_to_user_ids: [],
		leads_overview: {
			new_leads_count: 0,
			qualified_leads_count: 0,
			follow_up_leads_count: 0,
			site_visit_leads_count: 0,
			closed_leads_count: 0,
			not_interested_leads_count: 0,
			unassigned_leads_count: 0,
			assigned_leads_count: 0,
			total_leads: 0,
			leads_overview_loaded: false,
		},
		admins: [],
	},
	search_reviews_response: {
		reviews_ids: [],
		trigger_new_search: false,
		reviews_loading: true,
		initial_load_done: false,
		reviews_count: 0,
		filter_sort_field: "created_at",
		filter_sort_order: -1,
		filter_page_number: 1,
		did_user_already_review: false,
	},
	leads: [],
	search_saved_items_response: {
		saved_items_ids: [],
		trigger_new_search: false,
		saved_items_loading: true,
		initial_load_done: false,
		saved_items_count: 0,
		filter_listing_type: "property",
		filter_page_number: 1,
	},
	admins: {
		admins: [],
		is_admin_fetching: true,
		admin_loading: true,
		total_admins_count: 0,
		initial_load_done: false,
		viewer: null,
		business_profile_id: "",
	},
	search_analytics_response: {
		anal_graph_source: "",
		analytics_loading: false,
		filter_listing_type: "property",
		filter_listing_id: "",
		filter_graph_type_y: "leads",
		filter_graph_duration_x: "week",
		filter_start_date_x: "",
		filter_end_date_x: "",
		graph_screen_stat_total: 0,
		graph_screen_temp_data: null,
		graph_screen_x_axis: [],
		graph_screen_y_axis: [],
		overview_profile_views_loading: true,
		overview_profile_views: 0,
		overview_total_listing_leads_loading: true,
		overview_total_listing_leads: 0,
		overview_leads_difference_since_last_week: 0,
		overview_leads_is_difference_negative: false,
		overview_total_listing_views_loading: true,
		overview_total_listing_views: 0,
		overview_views_difference_since_last_week: 0,
		overview_views_is_difference_negative: true,
		overview_total_listing_saves: 0,
		overview_saves_difference_since_last_week: 0,
		overview_most_viewed_listing_loading: true,
		overview_most_viewed_listing_id: "",
		overview_most_viewed_listing_views: 0,
		overview_most_viewed_listing_views_difference_since_last_week: 0,
		overview_most_viewed_listing_is_difference_negative: false,
		overview_most_saved_listing_loading: true,
		overview_most_saved_listing_id: "",
		overview_most_saved_listing_saves: 0,
		overview_most_saved_listing_saves_difference_since_last_week: 0,
		overview_most_saved_listing_is_difference_negative: false,
		overview_most_leads_generated_listing_loading: true,
		overview_most_leads_generated_listing_id: "",
		overview_most_leads_generated_listing_leads: 0,
		overview_most_leads_generated_listing_leads_difference_since_last_week: 0,
		overview_most_leads_generated_listing_is_difference_negative: false,
	},
	search_boosts_response: {
		boost_ids: [],
		trigger_new_search: false,
		boosts_loading: true,
		initial_load_done: false,
		boosts_count: 0,
		filter_status: "all",
		filter_listing_type: "property",
		filter_sort_field: "created_at",
		filter_sort_order: -1,
		filter_page_number: 1,
		boosts_overview: {
			leads_count: 0,
			views_count: 0,
			saves_count: 0,
		},
	},
	search_ai_boosts_response: {
		active_boost: {
			active_boost_ids: [],
			active_boosts_count: 0,
			trigger_new_search: true,
			active_boosts_loading: true,
			initial_load_done: false,
			filter_page_number: 1,
		},
		completed_boost: {
			completed_boost_ids: [],
			completed_boosts_count: 0,
			trigger_new_search: true,
			completed_boosts_loading: true,
			initial_load_done: false,
			filter_page_number: 1,
		},
		recommended_properties_to_boost: {
			recommended_properties: [],
			recommended_properties_count: 0,
			trigger_new_search: true,
			recommended_properties_loading: true,
			initial_load_done: false,
			filter_page_number: 1,
		},
		property_count: 0,
		filter_status: "active",
		filter_sort_field: "created_at",
		filter_sort_order: -1,
		boost_load_complete: false,
	},
	property_ai_boost_details_meta: {
		filter_selected_platform: "combined",
		loading: true,
		leads_loading: true,
		budget_loading: true,
		impressions_loading: true,
		clicks_loading: true,
		ctr_loading: true,
		property_id: "",
		property_slug: "",
		landing_page_status: "",

		meta_leads_loading: true,
		meta_budget_loading: true,
		meta_impressions_loading: true,
		meta_clicks_loading: true,
		meta_ctr_loading: true,
		google_leads_loading: true,
		google_budget_loading: true,
		google_impressions_loading: true,
		google_clicks_loading: true,
		google_ctr_loading: true,

		banner_card_details: {
			property_id: "",
			boost_status: "",
			active_boost_id: "",
			active_boost_start_date: "",
			active_boost_end_date: "",
			active_boost_budget: 0,
			active_boost_plan: "",
			active_boost_exists: false,
			loading: true,
		},
		all_boosts_list_loading: true,
		all_boosts_list_response_status_code: "",
		all_boosts_list: [],
		filter_selected_boost_id: "",
		filter_start_date: "",
		filter_end_date: "",

		boost_metrics: {
			qualified_leads_count: 0,
			total_budget_spent: 0,
			total_budget: 0,
			total_impressions: 0,
			total_clicks: 0,
			ctr: 0,
		},

		meta_metrics: {
			qualified_leads_count: 0,
			total_budget_spent: 0,
			total_budget: 0,
			total_impressions: 0,
			total_clicks: 0,
			ctr: 0,
		},

		google_metrics: {
			qualified_leads_count: 0,
			total_budget_spent: 0,
			total_budget: 0,
			total_impressions: 0,
			total_clicks: 0,
			ctr: 0,
		},

		display_metrics: {
			qualified_leads_count: 0,
			total_budget_spent: 0,
			total_budget: 0,
			total_impressions: 0,
			total_clicks: 0,
			ctr: 0,
			source_platform: "meta",
		},

		all_campaigns_performance_metrics: {
			loading: true,
			meta_loading: true,
			google_loading: true,
			report_type: "campaign_wise",
			campaign_wise_list: {
				boosts: [],
			},
			meta_campaign_wise_list: {
				boosts: [],
			},
			google_campaign_wise_list: {
				boosts: [],
			},
			quarterly_list: [
				{
					quarter: "",
					total_budget_spent: 0,
					qualified_leads: 0,
					boosts: [],
				},
			],
			meta_quarterly_list: [
				{
					quarter: "",
					total_budget_spent: 0,
					qualified_leads: 0,
					boosts: [],
				},
			],
			google_quarterly_list: [
				{
					quarter: "",
					total_budget_spent: 0,
					qualified_leads: 0,
					boosts: [],
				},
			],
			date_range_list: {
				boosts: [],
			},
			meta_date_range_list: {
				boosts: [],
			},
			google_date_range_list: {
				boosts: [],
			},
		},
		ad_previews: {
			initial_load_done: false,
			filter_page_number: 1,
			filter_ad_id: "",
			ad_ids: [],
			total_ads_count: 0,
			loading: false,
			ads: [],
		},
		google_campaign_lists: [],
		google_campaign_details: {
			qualified_leads_count: 0,
			total_budget_spent: 0,
			total_budget: 0,
			impressions: 0,
			clicks: 0,
			ctr: 0,
			campaign_start_date: "",
			campaign_end_date: "",
		},
		activity_logs: {
			initial_load_done: false,
			activity_logs_loading: true,
			activity_logs: [],
			ai_summary: "",
			filter_page_number: 1,
			total_activity_logs_count: 0,
		},
	},
	current_screen: "home",
	anal_graph_source: "",
	search_beegru_point_transactions_response: {
		transactions: [],
		trigger_new_search: false,
		transactions_loading: true,
		initial_load_done: false,
		transactions_count: 0,
		filter_page_number: 1,
	},
	search_cash_transactions_response: {
		transactions: [],
		trigger_new_search: false,
		transactions_loading: true,
		initial_load_done: false,
		transactions_count: 0,
		filter_page_number: 1,
	},
	search_payment_transactions_response: {
		transactions: [],
		trigger_new_search: false,
		transactions_loading: true,
		initial_load_done: false,
		transactions_count: 0,
		filter_page_number: 1,
	},
	search_rewards_history_response: {
		rewards_history: [],
		trigger_new_search: false,
		rewards_history_loading: true,
		initial_load_done: false,
		rewards_history_count: 0,
		filter_page_number: 1,
	},
	search_rewards_response: {
		rewards: [],
		trigger_new_search: false,
		rewards_loading: true,
		initial_load_done: false,
	},
	search_referrals_response: {
		referrals: [],
		trigger_new_search: false,
		referrals_loading: true,
		initial_load_done: false,
		referrals_count: 0,
		filter_page_number: 1,
	},
	single_lead_details: {
		activity_log: [],
		assigned_to: [],
		created_by: {
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
		},
		enquiry_count: 0,
		id: "",
		is_guest: false,
		is_lead_from_boost: false,
		last_enquiry_at: "",
		listing_slug: "",
		listing_title: "",
		name: "",
		notes: "",
		phone: "",
		reminders: [],
		source: "",
		status: "",
		_id: "",
	},
	crm_integration_details: {
		initial_load_done: true,
		loading: false,
		is_enabled: false,
		webhook_info: {
			channel_id: "beegru",
			crm_name: "",
			api_method: "POST",
			webhook_url: "",
			api_key: "",
			headers: [],
		},
		payload_info: {
			channel_id: "channel_id",
			payload_type: "JSON",
			lead_id: "lead_id",
			name: "name",
			phone: "phone",
			email: "email",
			project_name: "project_name",
			status: "status",
			notes: "notes",
			lead_source: "lead_source",
			enquired_at: "enquired_at",
			api_key: "api_key",
		},
		test_response: {},
	},
	activity_logs: {
		initial_load_done: false,
		activity_logs_loading: true,
		filter_tab_value: "all",
		filter_activity_by: "all",
		filter_time_period: {
			start_date: "",
			end_date: "",
		},
		page: 1,
		page_size: 20,
		total_count: 0,
		total_pages: 0,
		members_and_admins: [],
		activity_logs: [],
	},
};

export const business_dashboard = business_dashboard_data;

export default business_dashboard_data;
